import React from 'react'

export default function PercentageOff({ price }) {
    const percentageOff = (1 - price?.promotion_price / price?.price) * 100
    // const nearest_5 = Math.ceil(percentageOff / 5) * 5
    return <>{percentageOff.toFixed(0)}</>
}
